module.exports = __webpack_public_path__ + "img/lg_ring_r_s_null_null@2x.574b0204.png";